import { Component, OnInit } from '@angular/core';
import {Shipping} from '../../../classes/shipping';
import {Billing} from '../../../classes/billing';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import {Inventories} from '../../../classes/inventories';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {CartService} from '../../../services/cart.service';
import { ProductsService } from '../../../services/products.service';
@Component({
  selector: 'app-useraddres',
  templateUrl: './useraddress.component.html',
  styleUrls: ['./useraddress.component.css']
})
export class UseraddressComponent implements OnInit {
  adtitle: any;
  flag: boolean;
  username: any;
  changeNeededflag: number;
  editflag: any;
  country: string;
  state: string;
  city: string;
  userid: any;
  dataship: Shipping[];
  billship: Billing[];
  loading= false;
  selectedShipaddid: any;
  action: any;
  msg1: any;
  constructor(private cartService: CartService, private router: Router,
    private commonService: CommonService, private productService: ProductsService,
     private snackbar: MatSnackBar, public route: ActivatedRoute) {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      this.username = udata .uname;
      //this.adtitle = this.route.snapshot.params['flag'];
      }

  ngOnInit() {
    this.loading = true;
    this.getUserBillingAddress();
    this.getUserShippingAddress();
  }
  openSnackBar() {
    this.snackbar.open(this.msg1 , this.action,{
      duration: 4000,
    });
  }
  getUserBillingAddress() {
    this.cartService.getUserBillingAddress(this.userid)
    .subscribe(
    (billship: Billing[]) => {
        this.billship = billship;
        this.loading = false;
        if (this.billship.length > 0) {
          this.setBilladdress();
        }
      });
  }
  getUserShippingAddress() {
    this.cartService.getUserAddress(this.userid)
    .subscribe(
      (dataship: Shipping[]) => {
        this.dataship = dataship;
        if (this.dataship.length > 0) {
          this.setBilladdress();
          this.generateEditFlag();
        }
        if ( this.loading === true) {
          this.loading = false;
        }
      });
  }
  setBilladdress() {
    if (this.billship && this.billship.length > 0 && this.billship[0].city_id === 1){
      this.city = 'Bangalore';
      this.state = 'Karnataka';
      this.country = 'India';
    }
    if (this.dataship && this.dataship.length > 0 && this.dataship[0].city_id === 1){
      this.city = 'Bangalore';
      this.state = 'Karnataka';
      this.country = 'India';
    }
  }
  deleteShippingAddress(id) {
    this.loading = true;
    this.cartService.deleteShipAddress(id)
    .subscribe(
      () => {
        this.loading = false;
        this.changeEffect();
      });
    this.msg1 = 'Remove Address Successfully';
    this.openSnackBar();
  }
  changeEffect() {
    this.loading = true;
    this.cartService.getUserAddress(this.userid)
        .subscribe(
          (dataship: Shipping[]) => {
            this.dataship = dataship;
            this.loading = false;
            this.moveBack();
          },
        );
      }
  changeradio(rid) {
    this.editflag = rid;
    this.selectedShipaddid = rid;
  }
  generateEditFlag() {
    for (let i = 0 ; i < this.dataship.length; i++) {
      if (this.dataship[i].isdefault === 1) {
        this.editflag = this.dataship[i].id;
        this.selectedShipaddid = this.dataship[i].id;
        break;
      }
    }
  }
  onSetShippingAddress() {
    this.loading = true;
    const ssid = this.selectedShipaddid;
   this.changeNeeded(ssid);
  }
   changeNeeded(ssid) {
    this.changeNeededflag = 0;
    for (let i = 0 ; i < this.dataship.length; i ++) {
      if (this.dataship[i].id == ssid && this.dataship[i].isdefault == 1) {
        this.changeNeededflag = 1;
        break;
      }
    }
    this.actionOnShipping(ssid);
  }
  actionOnShipping(ssid) {
    if (this.changeNeededflag > 0) {
    //  this.msg1 = 'Shipping Address Unchanged';
     // this.openSnackBar();
      this.loading = false;
      this.moveBack();
      } else {
      const y = 0;
      let sid: number;
        this.loading = true;
      this.updateonSetShippingAddress(ssid);
      for (let i = 0; i < this.dataship.length; i++) {
        sid = this.dataship[i].id ;
        if (sid !== ssid && this.dataship[i].isdefault === 1) {
          this.cartService.changeShipDefault(sid, this.userid, this.dataship[i].name,
            this.dataship[i].add_l1, this.dataship[i].add_l2, this.dataship[i].city_id,
            this.dataship[i].state_id, this.dataship[i].country_id,
            this.dataship[i].pin, this.dataship[i].phone, y, this.dataship[i].lat, this.dataship[i].lon)
          .subscribe(
            (dataship: Shipping[]) => {
              this.loading = false;
             });
        }
      }
    }
  }
  updateonSetShippingAddress(ssid) {
    const x = 1;
    for (let i = 0; i < this.dataship.length; i++) {
      if (this.dataship[i].id == ssid) {
        this.cartService.changeShipDefault(ssid, this.userid, this.username,
          this.dataship[i].add_l1, this.dataship[i].add_l2, this.dataship[i].city_id,
          this.dataship[i].state_id, this.dataship[i].country_id, this.dataship[i].pin,
          this.dataship[i].phone, x, this.dataship[i].lat, this.dataship[i].lon)
        .subscribe(
          (dataship: Shipping[]) => {
            this.loading = false;
            this.changeEffect();
            this.msg1 = 'Shipping Address changed';
            this.openSnackBar();
          });
        }
    }
  }
  moveBack() {
    this.router.navigate(['/store/checkout']);
  }
  setAsShipping() {
    this.loading =true;
    const isdefault = 0;
    this.flag = true;
       const uid = 0;
          let sid: number;
          const x = 1;
            for (let j = 0; j < this.dataship.length; j++){
              if (this.billship[0].add_l1 === this.dataship[j].add_l1 &&
                this.billship[0].add_l2 === this.dataship[j].add_l2
                && this.billship[0].user_id  === this.dataship[j].user_id &&
                this.billship[0].city_id === this.dataship[j].city_id && 
                this.billship[0].state_id === this.dataship[j].state_id && 
                this.billship[0].country_id === this.dataship[j].country_id && 
                this.billship[0].pin === this.dataship[j].pin && 
                this.billship[0].phone === this.dataship[j].phone &&
                this.billship[0].lat === this.dataship[j].lat &&
                this.billship[0].lon === this.dataship[j].lon) {
                this.flag = false; 
            }
          }
     if (!this.flag) {
        this.msg1 = 'Already added in shipping Address';
        this.loading =false;
        this.openSnackBar();
          this.moveBack();
      } else {
          for (let i = 0; i < this.dataship.length; i++) {
            if (this.dataship[i].isdefault === 1) {
              sid = this.dataship[i].id ;
              this.cartService.changeShipDefault(sid, this.userid,
                this.dataship[i].name, this.dataship[i].add_l1, this.dataship[i].add_l2, this.dataship[i].city_id,
                this.dataship[i].state_id, this.dataship[i].country_id, this.dataship[i].pin,
                this.dataship[i].phone, isdefault, this.dataship[i].lat, this.dataship[i].lon)
              .subscribe(
                (dataship: Shipping[]) => {
                  this.loading =false;
                }); }
           }
      this.cartService.createUserShippingAddress(this.userid,  this.billship[0].name,
            this.billship[0].add_l1, this.billship[0].add_l2,
            this.billship[0].city_id, this.billship[0].state_id,
            this.billship[0].country_id, this.billship[0].pin,
            this.billship[0].phone, x , this.billship[0].lat, this.billship[0].lon)
          .subscribe(
            () => {
              this.loading =false;
              this.changeEffect();
            }
            );
          this.msg1 = 'Shipping Address set';
          this.openSnackBar();
        }
  }
  editAddress(id, type) {
    this.productService.setEditaddressvalue(id);
      this.router.navigate(['/store/updateaddress/' + type]);
  }
}
